import React from 'react';
import './card.scss';
import classNames from 'classnames';

// карточка c белым фоном для переиспользования
export const Card = ({ children, className }) => {
	className = classNames('simple-card', className);
	return <div className={className}>{children}</div>;
};
